import ProviderBlueCross from '../../../../../common/icons/ProviderBlueCross';
import ProviderCanadaLife from '../../../../../common/icons/ProviderCanadaLife';
import ProviderClaimSecure from '../../../../../common/icons/ProviderClaimSecure';
import ProviderDesjardinsGroup from '../../../../../common/icons/ProviderDesjardinsGroup';
import ProviderGreenShieldCanada from '../../../../../common/icons/ProviderGreenShieldCanada';
import ProviderManulifeFinancial from '../../../../../common/icons/ProviderManulifeFinancial';
import ProviderManulifeFinancialHorizontal from '../../../../../common/icons/ProviderManulifeFinancialHorizontal';
import ProviderSunlifeFinancial from '../../../../../common/icons/ProviderSunlifeFinancial';
import ProviderSunlifeFinancialHorizontal from '../../../../../common/icons/ProviderSunlifeFinancialHorizontal';

export const featuredCanadianInsurance = {
  'manulife financial': {
    mobile: ProviderManulifeFinancialHorizontal,
    desktop: ProviderManulifeFinancial,
  },
  'sun life financial': {
    mobile: ProviderSunlifeFinancialHorizontal,
    desktop: ProviderSunlifeFinancial,
  },
  'canada life': {
    mobile: ProviderCanadaLife,
  },
  'green shield canada': {
    mobile: ProviderGreenShieldCanada,
  },
  'blue cross': {
    mobile: ProviderBlueCross,
  },
  'desjardins group': {
    mobile: ProviderDesjardinsGroup,
  },
  claimsecure: {
    mobile: ProviderClaimSecure,
  },
};
